import axios from 'axios'
switch(process.env.NODE_ENV) {
    case 'development':
        axios.defaults.baseURL = "https://zy.zlf.cn/api" //测试环境中的url
        //  axios.defaults.baseURL = "/api" //测试环境中的url
        break
    case 'alpha':
        axios.defaults.baseURL = "https://zy.zlf.cn/api" //测试环境中的url
        break
    case 'production':
        axios.defaults.baseURL = "https://zy.zlf.cn/api" //生产环境url
        break
}
export default axios.defaults.baseURL;